import React, { JSX } from "react";

import FastfoodIcon from "@mui/icons-material/Fastfood";
import {
  AddBusiness,
  AddHome,
  Diversity3,
  Savings,
  SportsTennis,
  Train,
  Work,
} from "@mui/icons-material";
import { Alarm } from "@mui/icons-material";
import { GiMuscleUp } from "react-icons/gi";
import { GiLeg } from "react-icons/gi";
import { FaRunning } from "react-icons/fa";

const IconComponents = {
  upperBody: <GiMuscleUp size={30} />,
  lowerBody: <GiLeg size={30} />,
  cardio: <FaRunning size={30} />,
  交際費: <Diversity3 fontSize="small" />,
  娯楽: <SportsTennis fontSize="small" />,
  交通費: <Train fontSize="small" />,
  給与: <Work fontSize="small" />,
  副収入: <AddBusiness fontSize="small" />,
  お小遣い: <Savings fontSize="small" />,
};

export default IconComponents;
